import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
  Avatar,
  Stack,
  Chip,
  Skeleton
} from '@mui/material';
import { Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
import { settingApi } from '../../api/api';
import { useNavigate } from 'react-router-dom';
export default function DeleteAdvertisement() {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    fetchAdvertisements();
  }, []);
  const fetchAdvertisements = async () => {
    try {
      setLoading(true);
      const res = await settingApi.getAllAdvertisement();
      if (res.data.success) {
        setAds(res.data.data);
      } else {
        console.error('Failed to fetch advertisements');
      }
    } catch (error) {
      console.error('Error loading ads:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this advertisement?')) return;
    setDeletingId(id);
    try {
      const res = await settingApi.advertisementsDelete(id);
      if (res.data.success) {
        setAds(prev => prev.filter(ad => ad.id !== id));
      } else {
        console.error('Failed to delete advertisement');
      }
    } catch (error) {
      console.error('Error deleting ad:', error);
    } finally {
      setDeletingId(null);
    }
  };
  return (
    <Box sx={{ p: 4, maxWidth: '1440px', mx: 'auto' }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ mb: 4 }}
      >
        <Typography variant="h5" fontWeight="bold">
          Advertisement Management
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/admin/AddAdvertisement')}
          sx={{
            bgcolor: 'primary.main',
            '&:hover': { bgcolor: 'primary.dark' }
          }}
        >
          Create New
        </Button>
      </Stack>
      <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
        {loading ? (
          <Box sx={{ p: 4 }}>
            {[...Array(5)].map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                height={56}
                sx={{ mb: 1, borderRadius: 1 }}
              />
            ))}
          </Box>
        ) : ads.length === 0 ? (
          <Box
            sx={{
              p: 8,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2
            }}
          >
            <Typography variant="h6" color="text.secondary">
              No advertisements found
            </Typography>
            <Button
              variant="outlined"
              onClick={() => navigate('/admin/AddAdvertisement')}
            >
              Create your first advertisement
            </Button>
          </Box>
        ) : (
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow sx={{ bgcolor: 'background.default' }}>
                {['Title', 'Type', 'Preview', 'Duration', 'Actions'].map((header) => (
                  <TableCell
                    key={header}
                    sx={{
                      fontWeight: 'fontWeightBold',
                      py: 2,
                      borderBottom: 'none'
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {ads.map((ad) => (
                <TableRow
                  key={ad.id}
                  hover
                  sx={{
                    '&:last-child td': { borderBottom: 'none' },
                    '&:hover': { bgcolor: 'action.hover' }
                  }}
                >
                  <TableCell sx={{ py: 2 }}>
                    <Typography fontWeight="medium">
                      {ad.title}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 2 }}>
                    <Chip
                      label={ad.ad_type}
                      size="small"
                      color={ad.ad_type === 'image' ? 'primary' : 'secondary'}
                      sx={{
                        textTransform: 'capitalize',
                        fontWeight: 'medium'
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ py: 2 }}>
                    {ad.ad_type === 'image' ? (
                      <Avatar
                        variant="rounded"
                        src={ad.file_path}
                        sx={{
                          width: 120,
                          height: 80,
                          boxShadow: 1,
                          borderRadius: 1
                        }}
                      />
                    ) : (
                      <Box
                        component="video"
                        src={ad.file_path}
                        sx={{
                          width: 120,
                          height: 80,
                          borderRadius: 1,
                          boxShadow: 1,
                          objectFit: 'cover'
                        }}
                        controls
                      />
                    )}
                  </TableCell>
                  <TableCell sx={{ py: 2 }}>
                    <Typography>
                      {ad.duration_seconds}s
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 2 }}>
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      disabled={deletingId === ad.id}
                      onClick={() => handleDelete(ad.id)}
                      startIcon={
                        deletingId === ad.id ? (
                          <CircularProgress size={16} />
                        ) : (
                          <DeleteIcon fontSize="small" />
                        )
                      }
                      sx={{
                        textTransform: 'none',
                        '&:hover': {
                          bgcolor: 'error.light',
                          color: 'error.dark'
                        }
                      }}
                    >
                      {deletingId === ad.id ? 'Deleting...' : 'Delete'}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Box>
  );
}


















